export const CustomLabel = (props: any) => {
  return (
    <g className='font-semibold text-xs'>
      <text x={0} y={-10} fill='#525252' dy={props.dy} dx={props.dx}>
        {props.title}
      </text>
    </g>
  )
}
